export { BaseError, type BaseErrorType } from './base';
export {
  UserRejectionError,
  type UserRejectionErrorType,
} from './userRejection';
